export default theme => ({
  checkLabel: {
    fontSize: 14,
  },
  check: {
    display: "inline-block",
    width: "auto",
  },
  checkContainer: {
    maxWidth: "100%",
  },
});
